import { type } from "../../types/types";

export default function reducer(
  state = { coupons: [], pagination: {} },
  action
) {
  switch (action.type) {
    case type.SET_COUPONS:
      return { ...state, ...action.coupons };
    default:
      return state;
  }
}
